export const SETCATEGORYSAVE = "SETCATEGORYSAVE";
export const SETCATEGORY = "SETCATEGORY";
export const SETACCOUNT = "SETACCOUNT";